"use strict";

var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var AceEditorComponent_1 = require("./AceEditorComponent");
var AceTextualRulerComponent = /*#__PURE__*/function (_AceEditorComponent_) {
  _inherits(AceTextualRulerComponent, _AceEditorComponent_);
  function AceTextualRulerComponent() {
    _classCallCheck(this, AceTextualRulerComponent);
    return _possibleConstructorReturn(this, _getPrototypeOf(AceTextualRulerComponent).apply(this, arguments));
  }
  _createClass(AceTextualRulerComponent, [{
    key: "getText",
    value: function getText() {
      return AceTextualRulerComponent.generateTextualRuler(this.props.alignment.getMaxSequenceLength());
    }
  }, {
    key: "getEditorMode",
    value: function getEditorMode() {
      return undefined;
    }
  }], [{
    key: "generateTextualRuler",
    /**
     * Generate a string axis (positional information) with one character per position
     * through the maxLength. Taken from alignmentviewer 1.0:
     *     https://github.com/sanderlab/alignmentviewer
     * May want to implement this better in the future (SVG + sliding tooltip for cursor?)
     * @param maxLength
     */
    value: function generateTextualRuler(maxLength) {
      var s = ""; // should be a better way to do this to be honest
      for (var i = 1; i <= maxLength + 1; i++) {
        var Q = i % 10 === 0;
        var Q5 = !Q && i % 5 === 0;
        s += Q ? "|" : Q5 ? ":" : ".";
        if (!Q) {
          continue;
        }
        var sn = "" + i;
        var np = s.length - sn.length - 1; // where num starts
        if (np < 0) {
          continue;
        }
        s = s.substr(0, np) + sn + "|";
      }
      return s; // this.hruler = s.replace(/ /g, '.');
    }
  }]);
  return AceTextualRulerComponent;
}(AceEditorComponent_1.AceEditorComponent);
exports.AceTextualRulerComponent = AceTextualRulerComponent;